export default {
  contactDetails: 'Contact Details',
  loadingContact: 'Loading contact...',
  contactNotFound: 'Contact not found.',
} as const;
